import { Component, computed, inject, signal } from '@angular/core';
import { RFavorietMap, RFavoriet } from '@cumlaude/service-contract';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { MappenDropdownComponent } from '../../../mappen-dropdown/mappen-dropdown.component';
import { DialogHeaderComponent, BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { PaginaSamenvattingComponent } from '../../../shared/components/pagina-samenvatting/pagina-samenvatting.component';

export type FavorietDialogResultaat = { favoriet: RFavoriet; nieuweMappen: RFavorietMap[] };

@Component({
	selector: 'app-favoriet-dialog',
	templateUrl: './favoriet-dialog.component.html',
	styleUrls: ['./favoriet-dialog.component.scss'],
	imports: [BaseDialogComponent, DialogHeaderComponent, MappenDropdownComponent, ButtonComponent, PaginaSamenvattingComponent],
})
export class FavorietDialogComponent {
	protected dialogRef = inject<DialogRef<FavorietDialogResultaat>>(DialogRef);
	protected data = inject<{
		template: RFavorietMap;
		mappen: RFavorietMap[];
		url: string;
		favoriet?: RFavoriet;
	}>(DIALOG_DATA);

	protected readonly title = this.data.favoriet ? 'Favoriet bewerken' : 'Favoriet aanmaken';

	protected readonly url = this.data.favoriet?.state ?? this.data.url;

	protected readonly account = this.data.favoriet?.account ?? this.data.template.account;

	protected readonly instelling = this.data.favoriet?.instelling ?? this.data.template.instelling;

	readonly naam = signal(this.data.favoriet?.naam ?? '');

	protected readonly selectedMap = signal<RFavorietMap | undefined>(
		this.data.mappen.find((map) => map.id === this.data.favoriet?.map?.id) ?? this.data.favoriet?.map
	);

	protected readonly nieuweMappen = signal<RFavorietMap[]>([]);

	protected readonly mappen = computed(() => [...this.data.mappen, ...this.nieuweMappen()]);

	protected readonly isNotEmpty = computed(() => this.naam().trim().length > 0);

	getResult(): FavorietDialogResultaat {
		const favoriet: RFavoriet = {
			$type: 'favoriet.RFavoriet',
			...this.data.favoriet,
			naam: this.naam(),
			account: this.account,
			instelling: this.instelling,
			state: this.url,
			map: this.selectedMap(),
		};
		return { favoriet, nieuweMappen: this.nieuweMappen() };
	}

	voegNieuweMapToe(map: RFavorietMap) {
		this.nieuweMappen.update((mappen) => [...mappen, map]);
	}

	close() {
		if (this.isNotEmpty()) this.dialogRef.close(this.getResult());
	}
}
